import * as React from 'react';
import List from '@mui/material/List';

export default function BoardList(props) {
  const { children } = props;

  return (
    <List sx={{ m: 0, p: 0, width: '100%', maxWidth: 360, bgcolor: 'background.paper', height: 255 }} dense>
      {children}
    </List>
  );
}
